import type { LucideIcon } from 'lucide-react'

interface EmptyStateProps {
  icon: LucideIcon
  message: string
  hint?: string
}

export function EmptyState({ icon: Icon, message, hint }: EmptyStateProps): JSX.Element {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-gray-100">
        <Icon size={24} className="text-gray-400" />
      </div>
      <p className="text-[14px] font-medium text-gray-700">{message}</p>
      {hint && <p className="mt-1 text-[13px] text-gray-400">{hint}</p>}
    </div>
  )
}
